export default {
    "label.update_translations_unsuccessful": "{count} елементів не вдалося:",
    "global.no_records": "Записів немає",
    "notifications.rp_has_been_updated": "Оновлено житловий проект Gold",
    "moduleTitle.files": "Файли",
    "label.coordinator": "Координатор",
    "sidebar.translations_managment": "Управління перекладами",
    "table.file": "Файл",
    "label.report_overview": "Огляд",
    "label.parent_agreement": "Форма згоди батьків для друку",
    "parentalConsent.i_consent_to_and_understand_that": "6. Я погоджуюся та розумію, що фотографії учасника, які беруть участь у певних заходах, пов’язаних із Премією, можуть бути зроблені, і такі фотографії можуть використовуватися в рекламних цілях за умови, що відповідна форма дозволу була підписана як учасником, так і його батьками/опікунами.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Я розумію, що учасники зобов’язані дотримуватися вимог Премії, які містяться в Книзі записів або ORB, політики та стандартів поведінки відповідного Оператора премії (з поправками, що час від часу вносяться) і вимог Центру Премії щодо плани на випадок надзвичайних ситуацій, оцінку діяльності та проведення Пригодницьких подорожей, пов’язаних із Премією, і розуміє, що Центр Премії може відкликати свій дозвіл на участь учасника в Премії, якщо вони не дотримуються.",
    "table.end_date": "Дата закінчення",
    "label.activation_date": "Дата активації",
    "label.report": "звіт",
    "label.award_is_offline": "Нагорода офлайн",
    "label.pending_changes": "Зміни в очікуванні...",
    "errors.min_nights_required": "Потрібна мінімум {nights} ночей",
    "label.country": "Країна / Територія",
    "notifications.award_leader_has_been_returned": "Переглянуто лідера премії",
    "notifications.participant_has_been_updated": "Учасника оновлено",
    "label.phone_number": "Телефонний номер",
    "roles.aj_assessor": "Оцінювач авантюрних подорожей",
    "notifications.person_state_has_been_changed": "Стан особи змінено",
    "pageTitle.dashboard": "Панель приладів",
    "moduleTitle.global_payment_method": "Глобальний спосіб оплати",
    "label.organization_type": "Тип організації",
    "button.account_settings": "Налаштування аккаунта",
    "notifications.contact_has_been_updated": "Контакт оновлено",
    "participant.recover_password": "Відновити пароль",
    "notifications.assessment_request_has_been_sent": "Запит на оцінку надіслано",
    "button.unassign": "",
    "label.start_date": "Дата початку",
    "label.assign_labels": "Призначити мітки",
    "sidebar.participants": "Учасники",
    "roles.coordinator": "Координатор",
    "label.organization_contact": "Організація Контакт",
    "tabs.customization": "Налаштування",
    "sidebar.award_units": "Нагородні центри",
    "button.change_goal": "Змінити ціль",
    "translationsManagement.selectProject": "Виберіть Проект",
    "award.rp": "Золотий житловий проект",
    "label.size": "Розмір",
    "label.bulk_action_results": "Масові результати дії",
    "notifications.activity_has_been_approved": "Діяльність дозволено",
    "label.payment_type": "Тип оплати",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Повторно надіслати запит на оцінку",
    "notifications.template_has_been_removed": "Шаблон видалено",
    "button.award_settings": "Налаштування нагороди",
    "pageTitle.payment": "Оплата",
    "tasks.return_award": "Переглянути нагороду",
    "label.link": "посилання",
    "moduleTitle.award_participant_delete": "Видалити нагороду учасника",
    "pageTitle.mro_related_contacts": "Мій регіональний офіс - пов'язані контакти",
    "pageTitle.my_organization_labels": "Моя організація - Мітки",
    "tabs.activity_signoff": "Розділ Авторизація",
    "table.logs": "Журнали",
    "moduleTitle.remove_file": "Видалити файл?",
    "label.email_confirmed": "Електронна адреса підтверджена",
    "notifications.activity_has_been_returned": "Діяльність переглянуто",
    "label.note": "Примітка",
    "button.show": "Показати",
    "tabs.adventurous_journey": "Пригодницька подорож",
    "sidebar.my_todolist": "Мій список справ",
    "label.here": "тут",
    "organisation.change_award_mode": "Змінити режим нагород",
    "table.note_from_al": "Записка від лідера нагородження",
    "label.gender": "Стать",
    "moduleTitle.remove": "видалити?",
    "errors.must_be_less_than": "Має бути менше ніж {limit}",
    "button.logout": "Вийти",
    "label.no_selected_participants": "Немає обраних учасників",
    "button.new_aj_event": "Нова подія «Авантюрна подорож».",
    "label.employement_status": "Зайнятість",
    "tabs.logs": "Журнали",
    "tabs.contacts": "Контакти",
    "label.option": "Варіант",
    "dashboard.charts": "Діаграми",
    "notifications.rp_has_been_approved": "Житловий проект Gold отримав дозвіл",
    "pageTitle.new_participant": "Новий учасник",
    "notifications.award_leader_has_been_approved": "Лідера нагородження уповноважено",
    "moduleTitle.would_you_like_to_remove_leader_training": "Чи бажаєте ви видалити тренінг Award Leaders?",
    "moduleTitle.update_configuration_value": "Оновити значення конфігурації",
    "table.description": "опис",
    "table.organization": "організація",
    "label.youtube": "YouTube",
    "label.author": "автор",
    "table.suitable_for_award_level": "Підходить для нагородного рівня",
    "label.content_update": "Будь ласка, зачекайте. Оновлення вмісту...",
    "notifications.new_question_has_been_added": "Нове питання додано",
    "pageTitle.nao_awards": "Національне бюро - Нагороди",
    "table.last_name": "Прізвище",
    "moduleTitle.adventurous_journey_detail": "Деталі подорожі",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Масова дія"},
    "label.project_location_type": "Тип розташування проекту",
    "label.email_help_award_level": "Рівень нагороди.",
    "label.date": "Дата",
    "label.previous_completed_award_place": "Де",
    "button.show_more": "Показати більше",
    "label.wwc_number": "Номер WWC",
    "button.filter": "фільтр",
    "notifications.rp_has_been_returned": "Житловий проект Gold був доопрацьований",
    "pageTitle.residetial_project_assessor_report": "Золотий житловий проект - Звіт експерта",
    "label.generating": "Створення...",
    "moduleTitle.finance_system_data": "Дані фінансової системи",
    "notifications.adventurous_journey_state_has_been_changed": "Стан Adventurous Journey змінено",
    "route.levels": "Рівні",
    "moduleTitle.activity_leader": "Керівник діяльності",
    "tasks.approve_event": "Схвалити подію",
    "tasks.reject_event": "Перегляд події",
    "table.region": "Регіон",
    "pageTitle.nao_award_leaders": "Національний офіс - нагородження керівників",
    "errors.must_be_at_least": "Мінімальна кількість символів: {min}",
    "table.title": "Назва",
    "table.last_activity": "Остання активність",
    "tasks.delete_registration": "Видалити реєстрацію",
    "table.date_time": "Місцевий час",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Оператори нагороди зобов’язуються поважати вашу конфіденційність. Особиста інформація збирається в цій формі з метою участі в Премії. Учасники, які не надають нам цю інформацію, не можуть брати участь у Конкурсі (зауважте, що це не стосується ненадання даних учасників). Ми також можемо використовувати вашу особисту інформацію, щоб надіслати вам інформацію про інші заходи чи події Премії, які, на нашу думку, можуть вас зацікавити. Ми можемо розкривати цю інформацію іншим місцевим або міжнародним організаціям і постачальникам послуг, які допомагають нам у роботі та управлінні Нагородою. Якщо ви хочете зв’язатися з нами або отримати доступ до своєї особистої інформації, будь ласка, напишіть Оператору нагороди. Ви також можете зв’язатися з оператором нагороди, щоб отримати копію його політики конфіденційності.",
    "aj.practice_journey": "Практична подорож",
    "notification.log_has_been_restored": "Журнал активності відновлено",
    "tabs.my_participants": "Мої учасники",
    "label.bulk_action_assign_label": "Призначити мітку",
    "moduleTitle.supervisor": "Керівник",
    "moduleTitle.your_parental_consent": "Ваша згода батьків",
    "route.registration_participants": "Реєстрація учасників",
    "placeholder.start_typing": "Почніть вводити...",
    "tasks.approve_award": "Затвердити нагороду",
    "route.registrations": "Реєстрації",
    "button.add_activity": "Додати активність",
    "notifications.aj_event_has_been_created": "Створено подію Adventurous Journey",
    "states.supervisor_approval": "Повноваження оцінювача",
    "label.description": "опис",
    "button.leave_anyway": "Все одно піти",
    "tabs.registrations": "Реєстрації",
    "states.leader_signoff": "Розділ Авторизація",
    "moduleTitle.forbidden": "Заборонено",
    "notifications.translations_has_been_updated.button": "Переклади успішно завантажено",
    "pageTitle.nao_registration": "Національний офіс - Реєстрація",
    "pageTitle.mro_logs": "Мій регіональний офіс - журнали",
    "meta.page_not_found": "Сторінку не знайдено",
    "label.bulk_action_unsuccessful": "{count} елементів не вдалося:",
    "global.days": "днів",
    "table.review": "огляд",
    "table.as_assessor_for": "Як суддя за",
    "roles.if_staff_statistical_user": "Статистичний користувач IF",
    "table.levels": "Рівні",
    "label.suitable_for_level": "Підходить для рівня",
    "pageTitle.leaders": "Лідери",
    "moduleTitle.send_test_email": "Надіслати тестовий електронний лист",
    "pageTitle.tasks_removed_registration": "Вилучено реєстрацію учасників",
    "label.you_will_be_forced_to_login_again_after_change": "Ви будете змушені повторно увійти після зміни",
    "table.recent_updates": "Нотатки та останні оновлення",
    "pageTitle.tasks_activity_signoffs": "Розділ Авторизація",
    "pageTitle.payments": "Платежі",
    "global.nights": "ночі",
    "label.blank_any_level": "БЛАНК на будь-якому рівні",
    "button.view_section": "Переглянути розділ",
    "moduleTitle.select_organization": "Виберіть організацію",
    "pageTitle.manual_data_import": "Ручний імпорт даних",
    "button.upload_files": "Завантажити файли",
    "label.migrated_contact_email": "Перенесено контактну електронну адресу",
    "label.for_award_unit": "Для нагородного центру",
    "label.aj_template_note": "Шаблон примітки",
    "table.last_log_added": "Останній доданий журнал",
    "button.view_participant": "Від Учасника",
    "label.please_comment_on_the_participants": "Будь ласка, прокоментуйте покращення/результативність/зобов’язання учасників",
    "label.consent_already_given_login": "Згоду вже дали. Будь ласка, увійдіть як ваша дитина.",
    "participant.level_start_date": "{value} Дата початку",
    "sidebar.my_region_office": "Мій регіональний офіс",
    "states.section_signoff": "Розділ Авторизація",
    "moduleTitle.assessor_details": "Реквізити оцінювача",
    "moduleTitle.adventurous_journey_settings": "Налаштування авантюрної подорожі",
    "moduleTitle.note_from_al": "Записка від лідера нагородження",
    "button.add_role": "Додати роль",
    "table.run": "бігти",
    "states.change_to_state_warning_missing_assessment": "УВАГА: Оцінка не додана. Ви все ще хочете продовжити?",
    "label.user_app_guide_leader": "Посібник користувача програми - Award Leader",
    "tabs.section_approval": "Розділ Авторизація",
    "roles.award_verifier": "Верифікатор нагороди",
    "tabs.activity_approval": "Авторизація діяльності",
    "logs.add_log": "Додати журнал",
    "tabs.award": "Нагорода",
    "notifications.this_role_has_read_only_persmission": "Ця роль має дозволи лише на читання",
    "table.no_filtered_results": "Немає відфільтрованих результатів",
    "button.praise": "коментар",
    "label.prevent_welcome_email_assessor": "Не надсилайте вітальний лист оцінювачу",
    "label.location_detail": "Деталі розташування",
    "label.optional": "(необов'язково)",
    "errors.do_not_match": "Не збігаються",
    "label.use_comma_for_multiple_entries": "Використовуйте кому для кількох записів",
    "label.operating_authority": "Операційний партнер",
    "label.activity_section": "Розділ діяльності",
    "notifications.you_have_been_logged_out": "Ви вийшли з системи",
    "table.finished": "Готово",
    "button.same_as_billing": "Те саме, що й виставлення рахунків",
    "table.payment": "Оплата",
    "table.current_level": "Поточний рівень",
    "button.view_nao": "Повернуто відділом нагородження (з приміткою про перегляд)",
    "table.email_confirmation": "Підтвердження електронною поштою",
    "moduleTitle.shipping_address": "Адреса доставки",
    "label.secondary_phone_type": "Тип додаткового телефону",
    "notifications.saved": "Збережено",
    "pageTitle.all_participants": "Всі учасники",
    "label.first_name": "Ім'я",
    "label.oa_price": "О. А. Ціна",
    "table.award_mode": "Режим нагородження",
    "tabs.api_keys": "Ключі API",
    "award.award_detail": "Деталі нагороди",
    "tabs.user_management": "Керування користувачами",
    "tabs.all_events": "Всі події",
    "notifications.history_record_has_been_removed": "Запис історії видалено",
    "award.no_data": "Дані для цієї нагороди ви не бачите.",
    "notifications.preparation_training_has_been_added": "Додано підготовку та навчання",
    "label.message": "повідомлення",
    "notifications.participant_info_updated": "Інформація про учасника оновлена",
    "roles.nao_staff": "Апарат НАО",
    "tabs.adventurous_journeys": "Пригодницькі подорожі",
    "label.gops": "",
    "route.upload": "Завантажити",
    "notifications.history_record_has_been_added": "Додано запис історії",
    "notifications.history_record_has_been_updated": "Запис історії оновлено",
    "label.no_data": "Ви не бачите даних для цієї премії.",
    "button.add_coordinator": "Додати координатора",
    "label.you_are_already_logged_as": "Ви вже ввійшли як ",
    "route.my_national_office": "Мій національний офіс",
    "tabs.leaders": "Лідери",
    "label.email_confirmation": "Підтвердження електронною поштою",
    "table.registration_date": "Дата Реєстрації",
    "notifications.role_has_been_removed": "Роль видалено",
    "button.move": "рухатися",
    "label.terms_and_conditions": "Правила та умови",
    "pageTitle.detail": "Подробиці",
    "table.award_unit": "Преміальний центр",
    "sidebar.settings": "Налаштування",
    "dashboard.leader_state": "Лідери - за штатом",
    "notifications.award_unit_has_been_approved": "Нагородний центр авторизовано",
    "states.awaiting_approval": "Очікується авторизація",
    "table.level": "Рівень",
    "table.action_requested": "Потрібна дія",
    "label.organisation_mode": "Режим організації",
    "label.no_note": "Без записки",
    "tabs.my_events": "Мої події",
    "notifications.participants_have_been_added": "Учасників додано",
    "tabs.registration_questions": "реєстр. Питання",
    "button.delete_registration": "Видалити реєстрацію",
    "notifications.parental_consent_link_has_been_sent": "Посилання батьківської згоди надіслано",
    "moduleTitle.select_role_organization": "Виберіть роль і організацію",
    "label.experience": "Досвід",
    "translationsManagement.modal.title": "Хочете оновити переклади?",
    "table.ic": "Незалежна країна",
    "table.id": "ID",
    "label.notify_email_explanation": "Учасника буде повідомлено електронною поштою про те, що його запит на оцінку не доставлено. Їх попросять виправити адресу електронної пошти та повторно надіслати запит на оцінку.",
    "participant.would_you_like_to_remove": "Ви б хотіли видалити цей обліковий запис?",
    "table.fields_included": "Поля включені",
    "label.user_guide_web_leader": "Веб-посібник користувача - Award Leader",
    "label.journey_type": "Тип подорожі",
    "button.setup": "Налаштування",
    "tabs.my_national_office": "Мій національний офіс",
    "notifications.training_has_been_removed": "Навчання видалено",
    "label.nominated_and_identified_persons": "Призначені та ідентифіковані особи, які можуть переглядати всі дані, але не редагувати",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Ви вийшли з системи через неактивність",
    "states.award_leader_signoff": "Авторизація лідера нагородження",
    "table.award_signoff_attempts": "Спроби нагородження",
    "sidebar.regions": "Регіони",
    "label.activity_deleted_note": "Ця діяльність видалена. Ви можете відновити його, натиснувши кнопку нижче.",
    "table.total": "Всього",
    "errors.a_problem_has_occured_during_processing": "Під час обробки виникла проблема, подивіться більше",
    "participant.participant_already_has_gold_award": "Учасник вже має золоту нагороду",
    "pageTitle.mro": "Мій регіональний офіс",
    "notifications.authorization_code_has_expired": "Термін дії коду авторизації минув",
    "moduleTitle.child_organization_labels": "Ярлики дочірніх організацій",
    "aj.aj_events": "Пригодницькі подорожі",
    "global.loading": "Завантаження",
    "label.gnipp": "GNIPP / ALF диск %  ",
    "sidebar.registrations": "Реєстрації",
    "label.any_string": "Будь-який рядок",
    "contact.change_contact_status": "Змінити статус контакту",
    "tabs.registration": "Реєстрація",
    "label.override_payment_note": "Перевизначити платіжну примітку",
    "notifications.section_has_been_signed_off": "Розділ виписано",
    "label.payment_date": "Дата оплати",
    "button.approve": "Затвердити",
    "moduleTitle.loggin_in": "Вхід в систему",
    "label.website": "Веб-сайт",
    "label.role": "роль",
    "table.assessor_report": "Звіт оцінювача",
    "label.ue_fe": "Інтерфейс залучення користувачів (статичні веб-мітки учасників)",
    "label.please_comment_on_the_participants_effort": "Будь ласка, прокоментуйте, як Учасник продемонстрував зусилля в досягненні мети діяльності",
    "label.previously_worked_as_assessor": "Раніше працював оцінювачем",
    "pageTitle.registrations": "Реєстрації",
    "parentalConsent.this_form_must_be_completed": "Цю форму <strong>повинні</strong> заповнювати батьки/опікуни для учасників віком до <strong> 18 років/національний вік юридичної відповідальності в країні, в якій ви проживаєте </strong> батьки/опікуни .",
    "button.apply": "Застосувати",
    "errors.include_at_least_one_number": "Додайте принаймні одну цифру",
    "label.content_restore": "Оновлення сеансу...",
    "logs.hour": "година",
    "parentalConsent.i_have_read_and_understand": "7. Я прочитав і зрозумів різні рівні та вимоги премії, викладені в Описі премії (сторінка 5 цієї форми).",
    "notifications.award_was_deleted": "Нагороду видалено.",
    "label.journey_category": "Тип подорожі",
    "notifications.search_cancelled": "Пошук перервано, потрібно дочекатися завершення пошуку.",
    "route.detail": "Деталь",
    "route.user_guide": "Керівництво користувача",
    "moduleTitle.history": "історія",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Непризначені учасники",
    "states.inactive": "Архів",
    "pageTitle.search_results": "Результати пошуку",
    "button.proceed_to_login": "Перейти до входу",
    "pageTitle.assessor_report_reject": "Перегляд звіту оцінювача",
    "notifications.contact_has_been_removed": "Контакт видалено",
    "sidebar.operating_authorities": "Операційні партнери",
    "label.no_note_from_participant": "Жодної примітки від учасника",
    "aj.preparation_and_training": "Підготовка та навчання",
    "route.user_guide_web_leader": "Веб-посібник користувача - Award Leader",
    "label.position_in_organization": "Посада в організації",
    "errors.emails_dont_match": "Електронна адреса не збігається",
    "route.my_participants": "Мої учасники",
    "pageTitle.customisations": "Налаштування",
    "tabs.localization_files": "Файли локалізації",
    "table.assessor_approval": "Повноваження оцінювача",
    "tabs.related_contacts": "Пов'язані контакти",
    "table.aus": "Нагородні центри",
    "table.category": "Категорія",
    "errors.file_is_too_large": "Максимальний розмір завантаження становить 20 Мб",
    "label.possible_values": "Можливі значення:",
    "label.if_your_download_doesnt_start": "Якщо завантаження не починається автоматично, натисніть тут",
    "route.independent_award_centres": "Незалежні нагородні центри",
    "pageTitle.user_guide": "Посібники користувача",
    "button.visit": "Відвідайте",
    "label.hours_first_letter": "ч",
    "pageTitle.my_organization_detail": "Моя організація - деталь",
    "pageTitle.nao_detail": "Національний офіс - Подробиці",
    "button.change": "Зміна",
    "award.aj": "Пригодницька подорож",
    "table.award_state": "Нагорода Держ",
    "pageTitle.tasks_award_signoff": "Дозвіл на присудження",
    "pageTitle.regions": "Регіони",
    "notifications.award_has_been_signed_off": "Нагорода підписана",
    "dashboard.award_approved_by": "Нагороди Авторизовано - за рівнями у 2016 році",
    "tabs.new_template": "Новий шаблон",
    "error.parent_email_must_be_filled": "Електронна адреса батьків має бути заповнена",
    "label.organisation_invoicing_name": "Ім'я ліцензіата",
    "pageTitle.related_contacts": "Пов'язані контакти",
    "button.try_again": "Закрийте попередження та повторіть спробу",
    "label.cannot_be_change_to_another": "Не можна змінити на інший рівень нагороди",
    "notifications.lead_coordinator_has_been_set": "Призначено нового провідного координатора",
    "label.training_name": "Назва навчання",
    "moduleTitle.new_contact": "Новий контакт",
    "translationsManagement.modal.updateTitle": "Ти впевнений?",
    "moduleTitle.offline_award_units_signoff": "Offline Award Leader signoff",
    "notifications.award_level_has_been_changed": "Рівень нагороди змінено",
    "label.subject": "Тема",
    "route.silver_level": "Срібний рівень",
    "label.privacy_notice": "Повідомлення про конфіденційність",
    "label.switch_organization": "Організація комутатора",
    "meta.dofe_name": "Міжнародна премія герцога Единбурзького",
    "route.profile": "Профіль",
    "roles.super_user": "Суперкористувач",
    "dashboard.while_you_were_gone": "Поки тебе не було",
    "label.no_note_from_award_leader": "Повернуто відділом нагородження (без примітки про перегляд)",
    "label.middle_name": "По батькові",
    "moduleTitle.new_activity": "Нова діяльність",
    "organisation.would_you_like_to_remove": "Чи бажаєте ви видалити цю організацію?",
    "label.state_province": "Штат / Провінція / Регіон",
    "moduleTitle.your_home_address": "Ваша домашня адреса",
    "tabs.sign_offs": "Авторизації",
    "moduleTitle.logs": "Журнали",
    "button.view_more": "Дивитись більше",
    "label.profile": "Профіль",
    "label.title": "Назва",
    "tabs.award_signoff": "Дозвіл на присудження",
    "label.post_code": "Поштовий індекс",
    "states.ceremony_certificate": "Церемонія",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Я даю згоду на надання будь-якої особистої інформації, яку я надав (включно з даними учасників), Центру нагород та Оператору нагород. Я даю згоду на обробку цієї інформації відповідно до положень політики конфіденційності відповідного оператора нагороди (зі змінами, які час від часу вносяться), Національних принципів конфіденційності, що містяться в Законі про захист даних (Великобританія) 1998 року (або будь-якої місцевої еквівалентної політики). або акт), а також будь-яке інше законодавство про конфіденційність, стандарти, вказівки чи інструкції, обов’язкові для них відповідно до законодавства про конфіденційність.",
    "label.user_guide_web_participant": "Веб-посібник користувача - Учасник",
    "label.award_unit_type": "Тип нагородного центру",
    "states.complete": "Повний",
    "table.participant_state": "Держава-учасник",
    "pageTitle.my_organization_payment": "Моя організація - оплата",
    "table.approved": "Авторизований",
    "pageTitle.my_organization_contacts": "Моя організація - Контакти",
    "warning.award_marked_as_paid_registration": "Попередження: ця реєстрація на нагороду позначена як платна.  Перед підтвердженням ознайомтеся з інструкціями щодо оплати та повернення коштів.",
    "states.change_to_state": "Змінити на <strong>{state}</strong>",
    "label.integer": "Ціле число",
    "notifications.translationUpdateInterrupted": "Оновлення перервано",
    "notifications.password_has_been_changed": "Пароль змінено",
    "button.invite_assessor": "Запросити оцінювача",
    "label.other_activity": "Інша діяльність",
    "notifications.parental_consent_has_been_sent": "Згода батьків надіслано",
    "button.revise": "переглянути",
    "errors.end_date_must_be_after_start_date": "Дата завершення має бути після дати початку",
    "label.award_leader_signoff_date": "Дата авторизації лідера нагородження",
    "parentalConsent.i_understand_every_participant_must": "8. Я розумію, що кожен учасник повинен брати участь у Премії через Центр Премії, який на власний розсуд має право прийняти чи відхилити учасників і запропоновані заходи, які мають бути здійснені в рамках Премії.",
    "moduleTitle.policies": "політики",
    "pageTitle.tasks_aj": "Пригодницька подорож",
    "global.day": "день",
    "moduleTitle.coordinator": "Координатор",
    "label.region": "Регіон",
    "button.add_history_record": "Додати запис історії",
    "moduleTitle.adventurous_journey_template_settings": "Параметри шаблону Adventurous Journey",
    "notifications.personal_details_have_been_updated": "Особисті дані оновлено",
    "sidebar.ics": "Незалежні країни",
    "table.independent_award_centre": "Незалежний нагородний центр",
    "label.undelivered_mail_reason": "Причина недоставки електронної пошти",
    "table.utc_date_time": "Час UTC",
    "moduleTitle.emails": "електронні листи",
    "label.backoffice": "Допоміжний офіс",
    "moduleTitle.parent_consent": "Згода батьків/опікунів",
    "label.photo_consent_given": "Учасник погоджується, що ми можемо використовувати його зображення профілю для просування",
    "moduleTitle.authorising_contact": "Власник ліцензії/Контактна особа, що уповноважує",
    "label.assessment_with_role": "{роль} оцінювання",
    "dashboard.type_of_awards": "Тип нагородного центру",
    "moduleTitle.payment": "Оплата",
    "states.in_progress": "В процесі",
    "logs.no_logs": "Без журналів",
    "sidebar.my_office": "Мій офіс",
    "label.assessor_report": "Звіт оцінювача",
    "notifications.rp_has_been_signed_off": "Житловий проект «Золото» підписано",
    "tabs.labels": "етикетки",
    "sidebar.payments": "Платежі",
    "meta.profile_questions": "Запитання профілю",
    "label.fax": "Факс",
    "label.email_help_custom_link": "Спеціальне посилання, якщо встановлено.",
    "label.last_name": "Прізвище",
    "organisation.manage_gop": "",
    "table.parental_consent": "Згода батьків",
    "dashboard.participant_by_level": "Учасники - за рівнем",
    "tabs.award_leaders": "Нагородження лідерів",
    "label.i_confirm_that_ive_witnessed": "Я підтверджую, що був свідком журналу реєстрації учасників для наведених нижче заходів",
    "table.lead_coordinator": "Провідний координатор",
    "states.deleted": "Видалено",
    "label.no_answers": "Немає відповідей",
    "button.add": "додати",
    "label.exchequer_number": "Казначейський номер кондиціонера",
    "label.waiting": "Очікування",
    "label.email_help_person_full_name": "ПІБ особи.",
    "tasks.return_registration": "Перегляд реєстрації",
    "notifications.state_aj_preparation_training_has_been_changed": "Підготовка та тренування до подорожі State of Adventure змінено.",
    "label.parent_approval": "Авторизація батьків",
    "table.assessor_approve": "Затверджує оцінювач",
    "errors.some_fields_requires_your_attention": "Деякі поля вимагають вашої уваги",
    "aj.qualifying_journey": "Кваліфікаційна подорож",
    "route.awards": "Нагороди",
    "table.registration": "Реєстрація",
    "pageTitle.assessors": "Засібники",
    "notifications.award_has_been_updated": "Нагороду оновлено",
    "errors.must_be_one_of": "Має бути одне з: {enums}",
    "pageTitle.logs": "Журнали",
    "notifications.notifications.invitation_has_been_sent": "Запрошення надіслано",
    "route.national_offices": "Національні офіси",
    "notifications.training_has_been_updated": "Навчання оновлено",
    "label.parent_last_name": "Прізвище Батька/Опікуна",
    "table.leaders": "Лідери",
    "states.award_level_complete": "Рівень нагороди пройдено",
    "button.reset": "Скинути",
    "sidebar.my_award_unit": "Мій центр нагород",
    "pageTitle.all_aj_events": "Усі авантюрні подорожі",
    "label.activity": "діяльність",
    "moduleTitle.are_you_sure": "Ти впевнений?",
    "route.gold_level": "Золотий рівень",
    "table.evidence": "Докази",
    "label.delivery_confirmed": "Доставка підтверджена",
    "parentalConsent.as_the_parent": "Як один із батьків/опікунів, я даю згоду на використання будь-яких зображень Фондом у рекламних цілях.",
    "label.awardMode.offline": "Офлайн",
    "tasks.approve_registration": "Підтвердити реєстрацію",
    "note.change_the_email_will_change": "Примітка. Зміна електронної адреси також змінить електронну адресу переміщеного контакту",
    "notifications.participant_has_been_approved": "Учасник авторизований",
    "label.reached_activity_limit": "Досягнуто ліміту активності в цьому розділі активності. У кожному розділі учасник може мати максимум 3 дії.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "Етикетку оновлено.",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Підготовку та навчання видалено",
    "pageTitle.settings": "Налаштування",
    "participant.level_registration_date": "{value} Дата реєстрації",
    "notifications.question_has_been_removed": "Питання видалено",
    "label.email_help_award_leader_full_name": "Повне ім'я керівника премії.",
    "sidebar.leaders": "Лідери",
    "notifications.participants_have_been_transferred": "Учасники переведені",
    "tabs.assessors": "Засібники",
    "sidebar.dashboard": "Панель приладів",
    "pageTitle.independent_award_centers": "Незалежні нагородні центри",
    "label.search": "Пошук",
    "moduleTitle.office_labels": "Офісні етикетки",
    "label.note_from_participant": "Примітка від учасника",
    "errors.required_field": "Обов'язкове поле",
    "tasks.approve_task": "Затвердити завдання",
    "logs.edit_log": "Редагувати журнал",
    "table.state": "Держава",
    "moduleTitle.level_summary": "Підсумок рівня",
    "moduleTitle.guides": "Посібники",
    "modal.close": "Закрити",
    "label.parent_first_name": "Ім'я батьків/опікуна",
    "parentalConsent.i_understand_that_the_participant": "1. Я розумію, що учасник не може брати участь у конкурсі, доки ця форма не буде заповнена (включаючи згоду батьків/опікунів) і не повернена відповідному Оператору конкурсу разом із відповідним реєстраційним внеском, а потім її прийнято Центром конкурсу.",
    "tabs.award_units": "Нагородні центри",
    "table.hours": "години",
    "label.type": "Тип",
    "notifications.adventurous_journey_has_been_removed": "Пригодницьку подорож видалено",
    "label.aj_is_not_approved_yet": "Adventurous Journey ще не авторизовано",
    "roles.authorizing_contact": "Авторизація контакту",
    "table.date_submitted_to_office_signoff": "Дата подання учасником / повернення відділом присудження",
    "notifications.section_has_been_returned": "Розділ переглянуто",
    "table.created_by": "Створений",
    "route.user_guide_web_participant": "Веб-посібник користувача - Учасник",
    "route.templates": "Шаблони",
    "states.awaiting_sign_off": "Авторизація лідера нагородження",
    "table.phone": "Телефон",
    "label.parental_consent": "Згода батьків",
    "label.org_contact_will_be_deleted": "Ви видаляєте останню роль цього контакта в цій організації. Чи бажаєте ви зберегти особисту інформацію як пов’язаний контакт чи повністю видалити контакт із цієї організації?",
    "route.bronze_level": "Бронзовий рівень",
    "label.invoice_currency": "Валюта рахунку",
    "button.new_label": "Нова етикетка",
    "error.server_cannot_be_reached_at_the_moment": "На даний момент сервер недоступний. Будь-ласка спробуйте пізніше.",
    "notifications.contact_has_been_created": "Контакт створено",
    "pageTitle.profile_questions": "Запитання профілю",
    "table.observation_files": "Файли спостереження",
    "table.participants": "Учасники",
    "tasks.no_evidence": "Доказів не надано",
    "button.edit": "Редагувати",
    "moduleTitle.leader": "Лідер",
    "notifications.new_template_has_been_updated": "Новий шаблон оновлено",
    "table.name": "Ім'я",
    "label.no_results": "Немає результатів",
    "moduleTitle.documents": "Документи",
    "button.invite": "запросити",
    "label.goal": "Мета",
    "pageTitle.nao_award_units": "Національний офіс - центри нагород",
    "label.award_delete_participant_id": "ID учасника",
    "errors.at_least_num_characters": "Принаймні {length} символів",
    "label.email_help_note": "Спеціальна примітка, якщо встановлено.",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Вилучити роль?",
    "label.total": "Всього",
    "label.delete_participant_award_info": "Ви збираєтеся стерти рівень нагороди. Це необоротно. правила:  а) учасник повинен мати більше, ніж нагороди   b) основна діяльність буде скинута, якщо вона була потрібна на рівні нагороди, який ви збираєтеся видалити   c) якщо після видалення залишиться дві нагороди, тоді основна дія буде встановлена на нижчу, лише якщо вона не перебуває в стані авторизації/завершення/церемонія. ",
    "route.leaders": "Лідери",
    "table.start_date": "Дата початку",
    "moduleTitle.coordinators": "Координатори",
    "button.create": "створити",
    "tabs.awards": "Нагороди",
    "parentalConsent.form_has_been_sent": "Згода батьків надіслано.",
    "states.journey_approval": "Дозвіл на поїздку",
    "pageTitle.reports": "Звіти",
    "table.journey_type": "Тип подорожі",
    "label.yes": "Так",
    "pageTitle.assessor_report": "Звіт оцінювача",
    "label.organization": "організація",
    "notifications.award_leader_has_been_updated": "Лідер премії оновлено",
    "moduleTitle.edit_role": "Редагувати роль",
    "table.journey_activity": "Подорож діяльності",
    "label.location": "Місцезнаходження",
    "label.update_translations_error_item": "Не вдалося оновити переклад для: {мова}, код: {localeCode}, проект: {projectCode}, оскільки",
    "pageTitle.adventurous_journeys": "Пригодницькі подорожі",
    "global.assessor": "Асесор",
    "moduleTitle.profile_questions": "Запитання профілю",
    "activity.cannot_edit_activity_if_award_in_state": "Неможливо редагувати діяльність, якщо нагорода має статус {state}",
    "moduleTitle.assessor_detail": "Реквізити оцінювача",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Я розумію, що після прийняття Центром нагородження учасник отримає Книгу записів або доступ до Книги записів онлайн (ORB). Учасник ознайомиться з вимогами Премії, що містяться в Книзі записів або ORB, перш ніж розпочати діяльність щодо Премії. Я розумію, що Центр нагородження має право на власний розсуд визначати, чи було виконано вимоги до нагороди, а отже, чи слід видати бронзову, срібну чи золоту нагороду. Я розумію, що Оператор нагороди може надати учасникам обмежене страхування від нещасних випадків і страхування громадської відповідальності, починаючи з моменту прийняття Премії Центром нагород, але що відповідальність за отримання та збереження особистого страхування від нещасних випадків лежить на учаснику/та його батько/опікун.",
    "notifications.award_has_been_returned": "Нагороду було переглянуто",
    "label.code_of_conduct": "Норми поведінки",
    "button.new_contact": "Новий контакт",
    "tabs.payments": "Платежі",
    "roles.naa_oa_staff": "Персонал НАА ОА",
    "label.switch_organisation_hint": "Ви можете будь-коли відкрити це діалогове вікно, вибравши «Змінити організацію» у верхньому правому куті меню",
    "label.expiration_date": "Термін придатності",
    "tabs.participants": "Учасники",
    "table.practice": "Практика",
    "notifications.one_activity_has_to_remain": "Одна діяльність у розділі має залишатися активною",
    "label.qualifications": "кваліфікація",
    "states.organization_approval": "Дозвіл офісу нагородження",
    "errors.must_be_an_integer": "Має бути цілим числом",
    "participant.send_confirmation_email_again_question": "Повторно надіслати електронний лист із підтвердженням?",
    "button.dismiss": "Відхилити",
    "table.advice": "Порада",
    "label.years_of_working_experience": "Роки досвіду роботи",
    "notifications.search_failed": "Під час пошуку сталася помилка. Будь-ласка спробуйте пізніше.",
    "notifications.changes_have_been_saved": "Зміни збережено",
    "moduleTitle.resend_parental_consent_link": "Повторно надіслати посилання батьківської згоди?",
    "label.activity_type": "Вид діяльності",
    "label.change_award": "Змінити рівень нагороди",
    "label.email": "Електронна пошта",
    "button.remove": "видалити",
    "button.download": "Завантажити",
    "label.vat_treatment": "Облік ПДВ",
    "pageTitle.aj_template_new": "Новий шаблон авантюрної подорожі",
    "table.per_page": "на сторінку",
    "notifications.translations_has_been_updated": "Переклади оновлено",
    "notification.award_mode_has_been_updated": "Режим нагородження оновлено",
    "tasks.revise_item": "Перегляд елемента",
    "button.resend_parental_consent": "Повторно надіслати згоду батьків",
    "table.weeks_completed_required": "Завершені тижні / обов'язкові",
    "label.last_modified": "Востаннє змінено",
    "table.major": "Майор",
    "label.vat_number": "ПДВ №",
    "errors.passwords_dont_match": "Паролі не співпадають",
    "table.country": "Країна / Територія",
    "sidebar.guides_and_policies": "Посібники та правила",
    "notifications.question_has_been_updated": "Питання оновлено",
    "table.participant_name": "Ім'я учасника",
    "label.registration_approval_date": "Дата затвердження реєстрації",
    "notifications.auth_code_is_no_longer_valid": "Код авторизації більше не дійсний",
    "errors.must_be_no_more_than": "Має містити не більше {max} символів",
    "notifications.event_has_been_rejected": "Подія була переглянута",
    "tabs.customizations": "Налаштування",
    "label.name_organization": "Ім'я",
    "button.add_log": "Додати журнал",
    "moduleTitle.invite_assessor": "Запросити оцінювача",
    "label.resend_confirmation_email": "Повторно підтвердження електронною поштою",
    "text.all_participants_will_be_transfered": "Усі учасники будуть передані новому лідеру нагородження",
    "label.repeat_email": "Повторно переслати електронну пошту",
    "errors.email_or_phone_required": "Потрібна електронна пошта або телефон",
    "notifications.role_has_been_updated": "Роль оновлено",
    "roles.if_staff_stat_user": "IF Статистичний користувач",
    "participant.delete_account": "Видалити контакт",
    "moduleTitle.would_you_like_to_remove_this_log": "Ви бажаєте видалити цей журнал?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "Підготуйте новий електронний лист",
    "table.journey_category": "Тип подорожі",
    "sidebar.manual_data_import": "Ручний імпорт даних",
    "label.created_after_date": "Створено після",
    "route.my_organization": "Моя організація",
    "button.show_list": "Показати список",
    "label.leaders": "Лідери",
    "notifications.log_has_been_modified": "Журнал змінено",
    "button.upload_file": "Завантажити файл",
    "moduleTitle.which_section_do_you_want_to": "Який розділ ви хочете повернути до «Виконується»?",
    "tabs.bronze_level": "Бронзовий рівень",
    "notifications.participants_have_been_saved": "Учасників врятовано",
    "pageTitle.aj_template_detail": "Пригодницька подорож",
    "label.parent_email": "Електронна адреса батьків/опікунів",
    "map.appr_location": "Приблизна адреса:",
    "notifications.log_has_been_removed": "Журнал видалено",
    "notifications.label_has_been_assigned": "Етикетку присвоєно.",
    "pageTitle.tasks_undelivered_emails": "Недоставлені електронні листи",
    "button.stay": "Залишся",
    "table.previous_level": "Попередній рівень",
    "label.award_start_date": "Дата початку нагородження",
    "assessor_report.returned_to_participant": "Повернуто учаснику",
    "pageTitle.tasks_assessors_registration": "Реєстрація оцінювача",
    "aj.cannot_modify_award": "Рівень нагороди не можна змінити, якщо учасники призначені на Пригодницьку подорож",
    "moduleTitle.lost_internet_connection": "Схоже, ви втратили з’єднання з Інтернетом",
    "states.ceremony": "Церемонія",
    "participant.reactivate_account": "Повторна активація облікового запису",
    "label.birthdate": "Дата народження",
    "pageTitle.assessment_send_successfully": "Оцінка успішно надіслана",
    "states.assessor_approval": "Повноваження оцінювача",
    "award.change_award_level": "Змінити рівень нагороди",
    "label.url_no_longer_valid": "Цей URL більше недійсний.",
    "button.update": "оновлення",
    "label.secondary_email": "Додаткова електронна адреса",
    "button.role_edit": "Редагувати",
    "table.award_leader": "Лідер премії",
    "label.level": "Рівень",
    "tasks.evidence": "Докази",
    "notifications.participant_is_already_in_list": "Учасник вже є в списку",
    "button.clear": "ясно",
    "label.allow_log_after_25_yoa": "Дозволити додавати журнали після 25 років",
    "states.setup": "Налаштування",
    "table.activity": "діяльність",
    "label.copy_to_clipboard": "{text} скопійовано в буфер обміну.",
    "route.award_units": "Нагородні центри",
    "button.upload_photo": "Завантажити зображення",
    "table.hours_completed_required": "Виконано/Потрібно",
    "table.first_name": "Ім'я",
    "notifications.adventurous_journey_has_been_returned": "Adventurous Journey переглянуто",
    "pageTitle.national_offices": "Національні офіси",
    "notifications.you_have_been_logged_in": "Ви увійшли в систему",
    "logs.offline": "Офлайн",
    "moduleTitle.add_role": "Додати роль",
    "label.user_app_guide_participant": "Посібник користувача програми - Учасник",
    "notifications.file_has_been_removed": "Файл видалено",
    "label.send_message": "Відправити повідомлення",
    "button.select": "Виберіть",
    "label.reason_of_deletion": "Причина видалення",
    "label.user_guide": "Керівництво користувача",
    "pageTitle.nao_participants": "Національне бюро - Учасники",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Завантажено",
    "tasks.approve_item": "Затвердити елемент",
    "tasks.restore_participant_registration": "Відновити реєстрацію учасника?",
    "label.awardMode.hybrid": "Гібрид",
    "table.first_activity_started": "Розпочато першу діяльність",
    "moduleTitle.dates": "дати",
    "table.no_results": "Немає результатів",
    "states.registration_approval": "Дозвіл на реєстрацію",
    "table.breakdown_of_hours": "Розбивка годин",
    "pageTitle.tasks_registration": "Реєстрація учасників",
    "button.create_new": "Створити новий",
    "sidebar.todolist": "Список справ",
    "label.active_participants": "Активні учасники",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Повторити завдання",
    "organisation.change_organisation_state": "Змінити стан організації",
    "moduleTitle.roles": "Ролі",
    "label.no_config_key_available": "Для цього розділу немає доступних ключів конфігурації",
    "placeholder.selectLanguage": "Оберіть мову",
    "states.office_signoff": "Дозвіл офісу нагородження",
    "notifications.translations_has_been_updated.failure": "Помилка оновлення перекладу",
    "logs.minute": "хвилина",
    "label.last_activity": "Остання активність",
    "sidebar.user_guide": "Посібники користувача",
    "label.trained_award_leader": "навчений лідер нагородження",
    "table.progress": "Прогрес",
    "table.suboperating_authorities": "Субопераційний партнер",
    "activity.cannot_edit_activity_offline": "Цей Учасник працює в автономному режимі.<br><br>  Ви не можете редагувати; активність, пригодницька подорож або Золотий житловий проект, якщо нагорода діє в напівавтономному режимі.",
    "label.user_does_not_have_permissions": "Користувач <strong>{user}</strong> не має дозволу переглядати цей вміст.",
    "notifications.assessor_has_been_approved": "Оцінювач уповноважений",
    "route.activity_approval": "Авторизація діяльності",
    "moduleTitle.role": "роль",
    "button.run": "бігти",
    "label.to": "до",
    "notifications.file_has_been_updated": "Файл оновлено",
    "moduleTitle.edit_coordinator": "Редагувати координатора",
    "notifications.authorization_code_is_no_longer_valid": "Код авторизації більше не дійсний",
    "button.reject": "переглянути",
    "label.label.participant_status": "Статус учасника",
    "award.gold_level": "Золотий рівень",
    "sidebar.variables": "Змінні",
    "parentalConsent.checkbox_copy": "Я підтверджую, що я є батьком/опікуном {firstName} {lastName}. Я даю згоду на те, щоб вони брали участь у конкурсі в {organisationName} під наглядом навченого керівника конкурсу. Я прочитав, зрозумів і погоджуюся з вимогами та умовами участі в Премії, як описано вище та на веб-сайті Оператора премії.",
    "button.go_to_dashboard": "Перейдіть на інформаційну панель",
    "button.add_option": "Додати варіант",
    "label.is_completed": "Виконано",
    "pageTitle.award_units": "Нагородні центри",
    "states.completed": "Виконано",
    "button.adventurous_journey_template_settings": "Параметри шаблону Adventurous Journey",
    "label.system_rights": "Системні права",
    "label.assessor_assesstment_award_start_date": "дата початку оцінювання",
    "label.update_translation_question": "Переклади для всіх існуючих мов для вибраних проектів буде оновлено.",
    "button.login": "Логін",
    "label.name_of_the_unit": "Назва підрозділу",
    "button.send": "Надіслати",
    "award.ajs": "Пригодницькі подорожі",
    "meta.payments_expired": "Платежі - закінчився",
    "label.age": "Вік",
    "notifications.payment_info_updated": "Платіжну інформацію оновлено",
    "table.is_completed": "Виконано",
    "table.invited_by": "Запрошено",
    "route.files": "Файли",
    "route.assessors": "Засібники",
    "info.aj_supervisor_is_mandatory": "Для практичної поїздки керівник отримає запит на оцінку, а для кваліфікаційної подорожі оцінювач отримає запит на оцінку.",
    "pageTitle.my_participants": "Мої учасники",
    "label.change_leader_status": "Зміна статусу лідера",
    "moduleTitle.parent_consent_form": "Форма згоди батьків/опікунів",
    "notifications.authorization_contact_has_been_set": "Контакт для авторизації встановлено",
    "button.close": "Закрити",
    "label.independent_country": "Незалежна країна",
    "notifications.aj_preparation_training_has_been_returned": "Підготовка та навчання до авантюрної подорожі було переглянуто",
    "route.history_log": "Журнал історії",
    "participant.account_settings": "Налаштування аккаунта",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} тому що",
    "label.orb_account": "Обліковий запис ORB",
    "notifications.file_url_is_not_specified_in_configuration": "URL-адреса файлу не вказана в конфігурації",
    "notifications.award_unit_has_been_removed": "Award Center/IAC видалено",
    "table.parent": "Батько",
    "label.mode_of_transport": "Спосіб подорожі",
    "label.parental_consent_email_info": "Не забудьте перевірити електронну пошту батьків і надіслати згоду вручну з екрана інформації про нагороду.",
    "label.current_award": "Актуальна премія",
    "table.action": "Дія",
    "pageTitle.suboperating_authorities": "Субопераційні партнери",
    "notifications.award_leader_has_been_assigned": "Визначено лідера нагородження",
    "tabs.sign_offs_locally": "Місцева авторизація",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "NAO",
    "tabs.aj_templates": "Шаблони авантюрної подорожі",
    "notifications.logging_out": "Вихід...",
    "label.update_label": "Оновити мітку",
    "button.organisation_settings": "Налаштування організації",
    "tabs.independent_award_centers": "Незалежні нагородні центри",
    "label.current": "поточний",
    "table.location": "Місцезнаходження",
    "button.search": "Пошук",
    "notifications.aj_preparation_training_has_been_approved": "Підготовка та навчання до авантюрної подорожі дозволено",
    "route.participants": "Учасники",
    "label.other_location_information": "Інша інформація про місцезнаходження",
    "label.number_of_records": "Кількість записів",
    "translationsManagement.infoLabel": "Ця функція дозволяє оновлювати переклади з POEditor",
    "parentalConsent.i_consent_to_pay_all": "5. Я погоджуюся оплатити всі такі витрати лікарів, медсестер або проживання в лікарні та витрати, понесені від імені учасника в результаті будь-якого такого нещасного випадку, травми, хвороби або втрати, понесеної учасником під час участі або подорожі до та з будь-яка діяльність або функції, пов'язані з Нагородою.",
    "label.nationality": "Національність",
    "states.approval": "Авторизація",
    "notifications.something_went_wrong": "Щось пішло не так",
    "aj.practice": "Практика",
    "label.addressLine2": "Адреса другого рядка",
    "label.please_leave_a_note": "Будь ласка, залиште записку",
    "placeholder.select": "Виберіть",
    "label.observations": "Спостереження",
    "label.aim": "Мета",
    "label.addressLine1": "Перша лінія адреси",
    "roles.aj_instructor": "Інструктор AJ",
    "meta.payments_waiting": "Платежі - Очікування",
    "label.award_to_delete": "Рівень нагороди для видалення",
    "label.category": "Категорія",
    "roles.instructor": "Інструктор",
    "moduleTitle.remove_customization_and_reset": "Видалити налаштування та скинути значення конфігурації?",
    "notifications.participant_registration_has_been_restored": "Реєстрацію учасників відновлено",
    "organisation.change_award_unit_mode": "Змінити режим організації",
    "table.organization_type": "Тип організації",
    "notifications.participant_has_been_deleted": "Учасника видалено",
    "label.language_settings": "Налаштування мови",
    "notifications.event_has_been_approved": "Захід авторизовано",
    "label.password": "Пароль",
    "label.text": "текст",
    "table.observations": "Спостереження",
    "notifications.participant_has_been_created": "Учасника створено",
    "table.note_for_al": "Примітка для керівника нагородження",
    "label.payment_confirmed": "Оплату підтверджено",
    "label.previous_completed_award_level": "Попередній рівень (не ORB)",
    "pageTitle.new_aj_event": "Нова подія «Авантюрна подорож».",
    "label.backend": "Бекенд",
    "label.relationship_to_participant": "Відношення до учасника",
    "award.physical_recreation": "Фізична рекреація",
    "contact.collect_emails": "Збирайте адреси електронної пошти для надсилання",
    "moduleTitle.assessor_report_reject": "Відхилення звіту оцінювача",
    "label.supervisor_report": "Звіт керівника",
    "table.role": "Роль",
    "route.user_guide_web_nao": "Веб-довідник користувача - NAO",
    "label.page_not_found": "404 - Сторінка не знайдена.",
    "table.labels": "етикетки",
    "notifications.file_has_been_uploaded": "Файл завантажено",
    "moduleTitle.address": "Адреса",
    "moduleTitle.lead_coordinator": "Провідний координатор",
    "pageTitle.login": "Логін",
    "label.frontoffice": "Фронт-офіс",
    "participant.would_you_like_to_remove_registration": "Ви бажаєте видалити цю реєстрацію?",
    "notifications.rp_has_been_setup": "Розпочато житловий проект Gold",
    "moduleTitle.award_unit": "Преміальний центр",
    "button.remove_file": "Видалити файл",
    "moduleTitle.billing_address": "Платіжна адреса",
    "pageTitle.my_aj_events": "Події моїх пригодницьких подорожей",
    "route.tasks": "завдання",
    "button.confirm": "Підтвердити",
    "label.national_award_authority": "Національний нагородний орган",
    "label.independent_award_centre": "Незалежний нагородний центр",
    "award.generate_award_report": "Створити звіт",
    "route.my_region_office_customization": "Мій регіональний офіс - налаштування",
    "label.email_help_aj_category": "Категорія «Пригодницька подорож».",
    "label.your_report_has_been_rejected": "Ви відхилили оцінку",
    "notifications.password_change_request_has_been_sent": "Запит на зміну пароля надіслано",
    "tabs.detail": "Деталь",
    "participant.change_participant_status": "Змінити статус учасника",
    "table.key": "ключ",
    "label.find_address": "Знайти адресу",
    "notifications.assessor_has_been_rejected": "Оцінювач переглянуто",
    "label.transfer_participants": "Трансфер Учасників",
    "button.continue_to_payment_gateway": "Продовжити до платіжного шлюзу",
    "notifications.participant_registration_has_been_removed": "Реєстрацію учасника видалено",
    "moduleTitle.page_not_found": "404 - Сторінка не знайдена",
    "route.adventurous_journeys": "Пригодницькі подорожі",
    "states.registration_assessment": "Реєстраційна оцінка",
    "heading.change_award_unit_mode": "Змінити режим Award Center",
    "label.user_guide_web_nao": "Веб-довідник користувача - NAO",
    "tabs.silver_level": "Срібний рівень",
    "table.paid_by": "Оплачено",
    "label.your_report_has_been_successfully_sent": "Ваш звіт успішно надіслано.",
    "sidebar.my_organization": "Моя організація",
    "pageTitle.participants": "Учасники",
    "notifications.preparation_training_has_been_updated": "Оновлено підготовку та навчання",
    "moduleTitle.server_is_unreachable": "Сервер недоступний",
    "label.last_activity_date": "Дата останньої активності",
    "award.bronze_level": "Бронзовий рівень",
    "moduleTitle.award_units": "Нагородні центри",
    "table.completed": "Виконано",
    "moduleTitle.revise_message": "Перегляньте повідомлення",
    "table.lastUsed": "Останнє використання",
    "award.bronze_to_gold_level": "Від бронзового до золотого рівня",
    "button.change_password": "Змінити пароль",
    "label.nao_price": "НАО Ціна",
    "label.payment_state": "Стан платежу",
    "label.wwc_expired": "Термін дії WWC минув",
    "label.award_office_signoff_date": "Дата авторизації відділу нагородження",
    "label.award_unit": "Преміальний центр",
    "award.gold_level_short": "золото",
    "moduleTitle.other_info": "Інша інформація",
    "table.note": "повідомлення",
    "label.search_by_email_first_or_last": "Шукайте по електронній пошті, імені або прізвищу",
    "tabs.history": "історія",
    "notifications.label_has_been_created": "Етикетку створено.",
    "tabs.unassigned_participants": "Непризначені учасники",
    "table.main_award_leader": "Координатор",
    "parentalConsent.i_as_the_parent": "3. Я розумію, що певна діяльність вважається високоризикованою, і що діяльність з високим ризиком може не покриватися страховими угодами Оператора премії. Я розумію, що відповідальність за всі ризики, пов'язані з участю учасника в Конкурсі, покладається виключно на учасника.",
    "label.state": "Держава",
    "notifications.award_leader_has_been_removed": "Лідера премії видалено",
    "tabs.organization_detail": "Деталі організації",
    "table.operating_authorities": "Операційний партнер",
    "label.available_labels": "Доступні етикетки",
    "modal.select": "Виберіть",
    "tabs.expired_payments": "Термін дії платежів закінчився",
    "moduleTitle.note_for_al": "Пам'ятка керівнику нагородження",
    "moduleTitle.confirm": "Підтвердити",
    "notification.new_activity_added": "Додано нову діяльність",
    "notifications.award_leader_has_been_moved": "Лідера нагородження переміщено",
    "label.award_mode": "Режим нагородження",
    "label.phone": "Телефон",
    "notifications.organization_has_been_updated": "Організацію оновлено",
    "moduleTitle.assessor": "Асесор",
    "label.bulk_action_confirmation": "Підтвердження масової дії",
    "table.parent_approval": "Авторизація батьків",
    "label.date_of_delivery": "Дата Отримання",
    "sidebar.assessors": "Засібники",
    "label.journey_activity": "Подорож діяльність",
    "award.inactive_award": "Інактивувати нагороду",
    "label.end_date": "Дата закінчення",
    "label.orb_testing": "Тестування ORB",
    "label.no_activities": "Жодної діяльності",
    "moduleTitle.please_confirm": "Будь-ласка підтвердіть",
    "button.login_with_another_account": "Увійдіть з іншим обліковим записом",
    "tasks.reject_registration": "Перегляд реєстрації",
    "label.submitted_after_date": "Подано після",
    "label.update_translations_successful": "{count} елементів успішно змінено.",
    "button.assign_leader": "Призначити лідера",
    "table.already_running": "Вже працює",
    "label.no": "Ні",
    "label.count_items_selected": "Вибрано елементів: {count}",
    "label.secondary_phone_number": "Додатковий номер телефону",
    "label.my_experience": "Мій досвід",
    "notifications.adventurous_journey_has_been_approved": "Adventurous Journey дозволено",
    "pageTitle.mro_detail": "Мій регіональний офіс - Деталі",
    "moduleTitle.nao_specific_info": "Спеціальна інформація NAO",
    "label.preparing_document_for_import": "Підготовка документа до імпорту",
    "tasks.observations": "Спостереження",
    "notifications.confirmation_email_has_been_sent": "Електронний лист із підтвердженням надіслано",
    "button.restore": "Відновлення",
    "label.importing_file": "Імпорт файлу",
    "label.or_dont_agree": "Або не згодні? Ти можеш",
    "moduleTitle.award_leader": "Лідер премії",
    "label.me": "(я)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Експорт таблиці",
    "organisation.move_award_unit": "Move Award Center",
    "label.file_category": "",
    "notifications.connecting_to_server": "Підключення до сервера...",
    "parentalConsent.i_understand_that_a_and_b": "11. Я розумію, що: <br /> a. учасник не повинен керувати транспортним засобом або перевозити інших учасників, які беруть участь у заходах, пов’язаних з Премією, якщо учасник не має належного та дійсного водійського посвідчення та не має відповідного страхування від третіх осіб для покриття будь-якої особи, яка постраждала внаслідок керування учасником. ; і <br /> b. учасник не повинен керувати будь-якою особою, яка не бере участі в організації Премії або не надає допомогу в її організації з метою участі в Конкурсі, за винятком випадків, коли ця особа має належне та дійсне водійське посвідчення та існує відповідне страхування від третіх осіб для покриття будь-яких особа, яка отримала травми внаслідок керування автомобілем.",
    "table.reason": "Причина",
    "pageTitle.contacts": "Контакти",
    "states.award_leader_approval": "Авторизація лідера нагородження",
    "meta.payments": "Платежі",
    "label.suboperating_authority": "Субопераційний партнер",
    "route.my_region_office": "Мій регіональний офіс",
    "states.registration_not_approved": "Реєстрація не авторизована",
    "label.direct_entrant": "Прямий учасник",
    "tabs.all_participants": "Всі учасники",
    "tabs.payment": "Оплата",
    "label.email_help_activity_name": "Назва діяльності.",
    "title.update_report": "Звіт про оновлення",
    "label.repeat_new_password": "Повторіть новий пароль",
    "label.other_roles": "Сторінка профілю ORB",
    "logs.hours": "години",
    "notifications.spreadsheet_has_been_imported_successfully": "Електронну таблицю успішно імпортовано",
    "label.bulk_action_question": "Виконати групову операцію з {count} елементами?",
    "moduleTitle.personal_details": "Персональні дані",
    "label.bulk_action_emailing": "Адреси електронної пошти обраних учасників",
    "route.my_events": "Мої події",
    "button.delete_award": "Видалити нагороду",
    "errors.include_both_lower_and_upper_case": "Додайте як нижні, так і великі символи",
    "tabs.removed_participant_registrations": "Вилучено реєстрацію учасників",
    "sidebar.mynao": "Мій NAO",
    "tabs.office_details": "Деталі офісу",
    "label.major": "Майор",
    "tabs.documents": "Документи",
    "label.new_password": "Новий пароль",
    "sidebar.adventure_journey": "Пригодницька подорож",
    "pageTitle.customizations": "Налаштування",
    "moduleTitle.assessor_report": "звіт {role}",
    "label.registration_date": "Дата Реєстрації",
    "notifications.training_has_been_added": "Додано навчання",
    "aj.qualifying": "Відбірковий",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Ви вийшли з системи, оскільки сеанс уже завершено",
    "award.service": "Волонтерська служба",
    "notifications.rp_state_has_been_changed": "Статус Житлового проекту Gold змінено",
    "label.ctest_access": "Тестовий доступ до сайту",
    "table.created": "Створено",
    "tasks.revise_task": "Повторити завдання",
    "button.assign": "Призначити",
    "button.return": "переглянути",
    "table.status": "Статус",
    "button.restore_activity": "Відновити активність",
    "tabs.new_aj_event": "Нова подія «Авантюрна подорож».",
    "roles.if_staff_viewer": "IAF Staff Viewer",
    "notifications.new_template_has_been_created": "Створено новий шаблон",
    "global.something_went_wrong": "Щось пішло не так",
    "table.expire_day": "День закінчення",
    "tabs.history_log": "Журнал історії",
    "label.form_of_payment": "Форма оплати",
    "button.add_training": "Додайте навчання",
    "label.par_reg_cust_note": "Ця вкладка дозволяє налаштувати поля, які відображаються під час реєстрації учасників, і впливати на обсяг даних, які ви збираєте.  Будь ласка, зверніться до свого регіонального офісу, якщо ви бажаєте внести зміни - лише системний адміністратор IAF має доступ для внесення цих змін.",
    "label.my_qualification": "Моя кваліфікація",
    "button.add_new_profile_question": "Додайте нове запитання профілю",
    "table.operating_authority": "Операційний партнер",
    "table.aim": "Мета",
    "table.awards": "Нагороди",
    "participant.deactivate_account": "Деактивувати обліковий запис",
    "table.organization_name": "організація",
    "label.email_help_award_leader_first_name": "Ім'я лідера нагородження.",
    "table.date": "Дата",
    "tasks.would_you_like_to_delete": "Ви бажаєте видалити цього учасника?",
    "notifications.configuration_value_has_been_updated": "Значення конфігурації оновлено",
    "ajTemplates.fill_from_template": "Заповнити з шаблону",
    "contact.send_test_email": "Надіслати тестовий електронний лист",
    "moduleTitle.aj_preparation_and_training": "Підготовка та тренування до авантюрної подорожі",
    "label.ce_be": "Настроювані електронні листи (переклад електронних листів)",
    "button.notify_participant": "Повернутися до Учасника",
    "label.parent_phone": "Номер телефону батьків/опікунів",
    "label.nao_regulations": "Регламент НАО",
    "award.skills": "Навички",
    "label.reject_application": "відхилити цю заявку.",
    "leader.delete_account": "Видалити контакт",
    "table.assign": "Призначити",
    "roles.aj_supervisor": "Керівник авантюрної подорожі",
    "label.logout": "Вийти",
    "moduleTitle.award_leader_edit": "Редагувати лідера нагородження",
    "moduleTitle.training": "Навчання",
    "notifications.coordinator_has_been_removed": "Координатора видалено",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Координатор",
    "label.bulk_action_successful": "{count} елементів успішно змінено.",
    "tasks.clear_email_revision": "Очистити версію електронної пошти",
    "table.preparation": "Підготовка",
    "table.delete": "Видалити",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Звіти",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "Учасник вже має велику активність на різних рівнях нагород. Ви хочете додати ще один?",
    "pageTitle.operating_authorities": "Операційні партнери",
    "label.delete_participant_award_modal_question_detail": "Ви справді хочете видалити {awardLevel} для учасника {participantId}?",
    "label.confirmed": "Підтверджено",
    "notifications.invitation_has_been_sent": "Запрошення надіслано",
    "pageTitle.independent_countries": "Незалежні країни",
    "label.assessors_email": "Електронна адреса оцінювача",
    "tasks.approve_assessor_registration": "Затвердити реєстрацію оцінювача",
    "table.award_duration": "Тривалість премії",
    "notifications.organization_has_been_moved": "Організацію переміщено",
    "pageTitle.nao_payment": "Національний офіс - Оплата",
    "participant.history_log": "Журнал історії",
    "label.rejected_with_note": "Відхилено з приміткою: \"{note}\"",
    "label.already_running": "Вже працює",
    "button.continue": "Продовжити",
    "award.no_data_to_show": "Немає даних для показу",
    "participant.send_email_invitation_again_question": "Знову надіслати запрошення електронною поштою?",
    "label.reason_for_changing_assessor": "Причина зміни засідателя",
    "button.delete": "Видалити",
    "moduleTitle.requirements_and_conditions": "Вимоги та умови",
    "roles.leader": "Лідер",
    "label.if_download_doesnt": "Якщо завантаження не починається автоматично, перевірте налаштування спливаючих вікон у своєму браузері",
    "dashboard.your_todo_list": "Ваш список справ",
    "notifications.award_unit_has_been_returned": "Центр нагородження було переглянуто",
    "moduleTitle.participant_activities": "Діяльність учасника",
    "errors.qualification_or_experience_required": "Потрібна кваліфікація або досвід",
    "label.active_leaders": "Активні лідери",
    "aj.preparation": "Підготовка",
    "button.change_state": "Змінити стан",
    "label.current_password": "Поточний пароль",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Налаштування контактів",
    "button.remove_photo": "Видалити фото",
    "notifications.activity_has_been_setup": "Діяльність налаштована",
    "errors.must_be_more_than": "Має бути більше ніж {limit}",
    "table.goal": "Мета",
    "notifications.coordinator_has_been_set": "Визначено координатора",
    "label.cc": "Cc",
    "label.duration": "Тривалість",
    "table.actions": "Дії",
    "participant.send_email_invitation_again": "Знову надіслати запрошення електронною поштою?",
    "moduleTitle.would_you_like_to_remove_participant": "Ви бажаєте видалити цю реєстрацію учасника?",
    "parentalConsent.i_authorise_employees": "4. Я дозволяю працівникам, посадовим особам або агентам Преміального центру та будь-яким іншим особам, які беруть участь, беруть участь або допомагають в організації Премії, у разі будь-якого нещасного випадку, травми, хвороби або втрати, яких зазнав учасник під час участі в , або поїздки до та з будь-якої діяльності чи функцій, пов’язаних із Нагородою, для отримання будь-якої необхідної медичної допомоги чи лікування, включаючи, але не обмежуючись, залученням будь-яких лікарів, медсестер або розміщенням у лікарні.",
    "button.reload_page": "Перезавантажити сторінку",
    "moduleTitle.update_translations": "Оновити переклади проекту",
    "label.report_description": "Включені поля та останні оновлення наразі доступні лише англійською мовою. Ми шукаємо рішення, щоб вони були доступні іншими мовами.",
    "table.email": "Електронна пошта",
    "label.new_goal": "Нова мета",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "невірна адреса електронної пошти",
    "pageTitle.new_contact": "Новий контакт",
    "sidebar.gops": "",
    "button.manage_participants": "Керувати учасниками",
    "errors.invalid_phone_format": "Недійсний номер телефону",
    "notifications.login_details_have_been_changed": "Дані для входу змінено",
    "moduleTitle.participant_logs": "Журнали учасників",
    "label.save": "зберегти",
    "label.frequently_asked_questions": "Часті запитання (FAQ)",
    "label.city": "Місто",
    "notifications.configuration_value_has_been_reset": "Значення конфігурації скинуто",
    "states.office_sign_off": "Дозвіл офісу нагородження",
    "button.save": "зберегти",
    "button.import_data_from_selected_file": "Імпортувати дані з вибраного файлу",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Я розумію, що учасник не може розпочинати жодного конкретного розділу Премії, доки я не переконаюся, що будь-який волонтер, призначений учасником, який не є співробітником Центру премії, має відповідний досвід та/або кваліфікацію для інструктажу/нагляду/ оцінити цей розділ Нагороди; і доки відповідні волонтери не заповнять і не повернуть необхідну документацію до Центру нагород.",
    "pageTitle.apiKeys": "Ключі API",
    "label.international_region": "Міжнародний регіон",
    "tabs.levels": "Рівні",
    "tabs.additional_files": "Додаткові файли",
    "label.continuation_level": "Рівень продовження",
    "table.adventurous_journey_detail": "Деталі пригодницької подорожі",
    "button.set": "встановити",
    "label.i_certify_that_as_the_assessor": "Я засвідчую, що {роль} цієї діяльності учасник відповідає вимогам.",
    "table.coordinator": "Координатор",
    "participant.send_confirmation_email_again": "Повторно надіслати електронний лист із підтвердженням?",
    "table.report": "звіт",
    "label.update_translations_results": "Оновити результати перекладів",
    "table.observation_note": "Спостереження",
    "label.view_more": "Дивитись більше",
    "notifications.payment_link_has_been_reset": "Платіжне посилання скинуто",
    "table.type": "Тип",
    "moduleTitle.updateConfigurationKey": "Оновити ключ конфігурації",
    "sidebar.independent_award_centers": "Незалежні нагородні центри",
    "table.activity_type": "Вид діяльності",
    "label.awardMode.online": "Онлайн",
    "table.data_state": "Останнє оновлення даних",
    "button.generate_report": "Створити звіт",
    "moduleTitle.assessed_by_award_leader": "Оцінює лідер премії",
    "table.child_protection_number": "Номер захисту від дітей",
    "button.bulk_change": "Масова зміна",
    "label.send_welcome_email": "Надіслати привітальний лист",
    "label.award_state": "Нагорода Держ",
    "moduleTitle.overview": "Огляд",
    "table.aj_detail": "Деталі авантюрної подорожі",
    "pageTitle.tasks_activity_approvals": "Авторизація діяльності",
    "label.section": "Розділ",
    "route.history": "історія",
    "route.event_participants": "Учасники заходу",
    "participant.account_detail": "Налаштування аккаунта",
    "route.dashboard": "Панель приладів",
    "table.payments": "Платежі",
    "pageTitle.profile": "Профіль",
    "organisation.remove_organisation": "Видалити організацію",
    "pageTitle.my_organization": "Моя організація",
    "label.award_leader": "Лідер премії",
    "notifications.assessor_has_been_updated": "Оцінювач оновлено",
    "label.participant_personal_reflection": "Особиста рефлексія учасника",
    "button.add_key": "Додати ключ",
    "header.appMotto": "ГЕРЦОГ",
    "table.qualifying": "Відбірковий",
    "button.upload": "Завантажити",
    "button.resend": "Надіслати повторно",
    "label.filename": "Ім'я файлу",
    "label.change_parental_consent": "Згода батьків з паперу на електронну",
    "button.cancel": "Скасувати",
    "label.aply_to_all_langs": "Застосовувати до всіх мов",
    "route.customization": "Налаштування",
    "errors.minimal_duration_is": "Мінімальна тривалість 30 хв",
    "label.email_help_participant_first_name": "Ім'я учасника.",
    "label.participant_status": "Статус учасника",
    "award.bronze_level_short": "Бронза",
    "label.phone_type": "Тип телефону",
    "global.night": "ніч",
    "button.adventurous_journey_settings": "Налаштування авантюрної подорожі",
    "participant.leader_must_be_selected": "Треба вибрати лідера",
    "pageTitle.translationsManagement": "Управління перекладами",
    "moduleTitle.user_added_preparation_and_training": "Додані користувачем підготовка та навчання",
    "table.approve": "Затвердити",
    "label.role_in_organisation": "Роль в організації",
    "states.finished": "Готово",
    "label.created": "Створено",
    "button.back_to_home": "Назад додому",
    "label.options": "Опції",
    "contact.next_level_invitation": "Запрошення наступного рівня",
    "moduleTitle.activity_detail": "Деталі діяльності",
    "route.section_signoff": "Розділ Авторизація",
    "moduleTitle.assign_labels_bulk": "Призначте вибрані мітки ${itemCount} учасникам.",
    "button.contact_settings": "Налаштування контактів",
    "label.transation_id": "ID транзакції",
    "notifications.activity_has_been_updated": "Активність оновлено",
    "sidebar.awards": "Нагороди",
    "parentalConsent.images_consent": "Як один із батьків/опікунів, я даю згоду на використання будь-яких зображень Фондом у рекламних цілях.",
    "participant.would_you_like_to_delete": "Ви б хотіли видалити цей обліковий запис?",
    "roles.user": "Статистичний",
    "label.label": "Мітка",
    "label.select_sheet": "Виберіть аркуш на комп’ютері",
    "global.no_results": "Немає результатів",
    "moduleTitle.address_line_2": "Адреса другого рядка",
    "states.awaiting_office_sign_off": "Дозвіл офісу нагородження",
    "moduleTitle.export": "Експорт",
    "moduleTitle.address_line_1": "Перша лінія адреси",
    "notifications.participant_has_been_assigned": "Учасника призначено",
    "roles.viewer": "Переглядач",
    "label.participants_total": "Всього учасників",
    "errors.auth_code_is_no_longer_valid": "Код авторизації більше не дійсний - можливо, він був використаний або термін його дії минув",
    "label.file_is_not_available": "Файл недоступний",
    "button.select_template": "Виберіть Шаблон",
    "label.payment": "Оплата",
    "award.silver_level_short": "Срібло",
    "table.participant_id": "ID учасника",
    "text.hours_old": "{hours} годин тому",
    "moduleTitle.your_personal_information": "Ваша персональна інформація",
    "aj.minimum_date_recommendation": "Рекомендована мінімальна дата для практики AJ і {name}",
    "label.date_of_payment": "Дата оплати",
    "button.view": "Переглянути",
    "label.create_new_label": "Створити нову мітку",
    "title.confirmation": "Підтвердження",
    "button.set_participants": "Набір учасників",
    "roles.assessor": "Асесор",
    "moduleTitle.coordinator_settings": "Налаштування координатора",
    "label.parent_relationship": "Батьківські стосунки",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "Повідомлення було відправлено",
    "label.email_help_participant_full_name": "ПІБ учасника.",
    "sidebar.suboperating_authorities": "Субопераційні партнери",
    "route.award": "Нагорода",
    "label.no_roles": "Жодних ролей",
    "table.files": "Файли",
    "aj.minimum_date_requirements": "Мінімальна дата для кваліфікаційного AJ та {name} така",
    "pageTitle.labels": "етикетки",
    "label.participant_is_semi_offline": "Учасник офлайн",
    "moduleTitle.other_coordinators": "Інші координатори",
    "button.updateSelectedLanguage": "Оберіть мову",
    "tasks.approve_award_registration": "Затвердити реєстрацію нагороди",
    "participant.invite_participant_to_next_level": "Запросити учасника на наступний рівень?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Нагороди",
    "warning.award_marked_as_paid": "Попередження: є принаймні один рівень нагороди або реєстрація, позначена як платна.  Перед підтвердженням ознайомтеся з інструкціями щодо оплати та повернення коштів.",
    "table.edit": "огляд",
    "states.change_to_state_warning_missing_hours_to_complete": "ПОПЕРЕДЖЕННЯ: мінімальна необхідна кількість годин не була зареєстрована. Ви все ще хочете продовжити?",
    "label.dofe": "Міжнародна премія",
    "moduleTitle.after_assigning_a_role_to_yourself": "Після призначення або зміни ролі вам потрібно буде повторно увійти.",
    "label.transaction_id": "ID транзакції",
    "table.suboperating_authority": "Субопераційний партнер",
    "label.participant_survey": "Учасник отримає запрошення на дослідження Фонду.",
    "label.created_by": "Створений",
    "button.send_confirmation_email_again_question": "Ще раз надішліть електронний лист із підтвердженням",
    "label.email_help_award_leader_email": "Електронна адреса керівника премії.",
    "label.name": "Ім'я",
    "tabs.gold_level": "Золотий рівень",
    "pageTitle.award_documents": "Нагородні документи",
    "label.online_payments": "Онлайн платежі",
    "label.child_protection_number": "Номер захисту від дітей",
    "participant.send_password_recovery_email": "Надіслати електронний лист для відновлення пароля?",
    "notifications.new_log_has_been_added": "Додано новий журнал",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Назва організації",
    "pageTitle.my_organization_templates": "Моя організація - Шаблони",
    "pageTitle.award_leaders": "Нагородження лідерів",
    "label.status": "Статус",
    "label.street": "вул",
    "roles.if_staff_superuser": "Персональний суперкористувач IAF",
    "table.licence_holder": "Власник ліцензії",
    "label.created_at": "Створено в",
    "table.section": "Розділ",
    "table.system_rights": "Системні права",
    "label.iac_type": "Тип IAC",
    "label.other": "Інший",
    "moduleTitle.login": "Логін",
    "label.no_data_to_show": "Немає даних для показу",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Рівень нагороди не можна змінити, якщо учасники призначені на Пригодницьку подорож",
    "tabs.waiting_payments": "Очікування платежів",
    "global.supervisor": "Керівник",
    "notifications.new_role_has_been_added": "Додано нову роль",
    "award.silver_level": "Срібний рівень",
    "heading.change_awards_mode": "Змінити режим нагороди",
    "button.save_changes": "Зберегти зміни",
    "organisation.would_you_like_to_move_award_unit": "Куди б ви хотіли перемістити цю організацію?",
    "label.fields": "",
    "label.email_help_organization_name": "Назва центру нагородження.",
    "pageTitle.mro_related_detail": "Мій регіональний офіс - Деталі",
    "table.started_at": "Розпочато о",
    "parentalConsent.i_consent_to_the_award_unit": "2. Я даю згоду Центру Премії та будь-яким іншим особам, включаючи волонтерів*, які беруть участь або допомагають в організації Премії, а також найнятим транспортним водіям, які перевозять учасника з метою участі в заходах або функціях, пов’язаних з Премією, в міру необхідності. Я розумію, що Преміальний центр повідомить мене заздалегідь про те, коли і куди відбудеться така поїздка.",
    "logs.minutes": "хвилин",
    "label.total_participants": "Всього учасників",
    "moduleTitle.contact_info": "Контактна інформація",
    "table.payment_link": "Посилання для оплати",
    "errors.please_contact_your_local_award_staff": "Будь ласка, зверніться до місцевого відділу нагородження."
}